import { MessageCircle, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import WhatsAppConnector from "@/components/admin/WhatsAppConnector";
import TelegramConnector from "@/components/admin/TelegramConnector";

const MobileSettings = () => {
  return (
    <div className="flex flex-col gap-4 p-4 overflow-y-auto flex-1">
      <h1 className="text-xl font-semibold">Settings</h1>

      {/* WhatsApp */}
      <Card>
        <CardHeader className="pb-3">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-green-100 dark:bg-green-900/30 shrink-0">
              <MessageCircle className="h-5 w-5 text-green-600" />
            </div>
            <div>
              <CardTitle className="text-base">WhatsApp</CardTitle>
              <CardDescription>Receive alerts and reports on WhatsApp</CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <Sheet>
            <SheetTrigger asChild>
              <Button className="w-full" variant="outline">
                <MessageCircle className="h-4 w-4 mr-2 text-green-600" />
                Connect to WhatsApp
              </Button>
            </SheetTrigger>
            <SheetContent side="bottom" className="h-[85vh] overflow-y-auto p-0">
              <WhatsAppConnector />
            </SheetContent>
          </Sheet>
        </CardContent>
      </Card>

      {/* Telegram */}
      <Card>
        <CardHeader className="pb-3">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-100 dark:bg-blue-900/30 shrink-0">
              <Send className="h-5 w-5 text-blue-500" />
            </div>
            <div>
              <CardTitle className="text-base">Telegram</CardTitle>
              <CardDescription>Receive alerts and reports on Telegram</CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <Sheet>
            <SheetTrigger asChild>
              <Button className="w-full" variant="outline">
                <Send className="h-4 w-4 mr-2 text-blue-500" />
                Connect to Telegram
              </Button>
            </SheetTrigger>
            <SheetContent side="bottom" className="h-[85vh] overflow-y-auto p-0">
              <TelegramConnector />
            </SheetContent>
          </Sheet>
        </CardContent>
      </Card>
    </div>
  );
};

export default MobileSettings;
